import React from "react";
import { Container, ListGroup, Button, Badge, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";  
import "./Cart.css";

export default function Cart({ cart = [], onChangeQty, removeFromCart }) {
  const total = cart.reduce((sum, item) => sum + item.unit_price * item.quantity, 0);
  const navigate = useNavigate();  

  const goToCheckout = () => {
    navigate("/checkout");  
  };

  return (
    <Container className="cart-container mt-4">
      <h2 className="cart-title text-light mb-4">🛒 Your Cart</h2>
      {cart.length === 0 ? (
        <div className="cart-empty text-center text-muted py-5">
          <p>Your cart is empty.</p>
        </div>
      ) : (
        <>
          <ListGroup variant="flush">
            {cart.map(item => (
              <ListGroup.Item
                key={item.product_id}
                className="cart-item d-flex justify-content-between align-items-center bg-dark text-light"
              >
                <div>
                  <span className="cart-item-name">{item.name}</span>{" "}
                  <Badge bg="warning" text="dark">x{item.quantity}</Badge>
                </div>
                <div className="d-flex align-items-center">
                  <span className="cart-item-price me-3">
                    R {(item.unit_price * item.quantity).toFixed(2)}
                  </span>
                  <Button
                    variant="outline-warning"
                    size="sm"
                    className="cart-remove-btn"
                    onClick={() => removeFromCart(item.product_id)}
                  >
                    ✕
                  </Button>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
          <Row className="mt-4">
            <Col className="text-end">
              <h4 className="cart-total text-warning">
                Total: R {total.toFixed(2)}
              </h4>
              <Button 
  className="cart-checkout-btn" 
  onClick={goToCheckout}
>
  Proceed to Checkout
</Button>

            </Col>
          </Row>
        </>
      )}
    </Container>
  );
}
